import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Autosuggest from 'react-autosuggest';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestions(value, component) {
  if (Tefter.user_signed_in) {
    const path = '/suggestions';
    const params = { prefix: value, user_id: Tefter.feed_id, list_id: Tefter.list_id,
                     organization_id: Tefter.organizationId };

    $.getJSON(path, params, function(response){
      component.setState({
        suggestions: response.suggestions
      });
    });

  }
  else {
    component.setState({
      suggestions: []
    });
  }
}

function getSuggestionValue(suggestion) {
  return suggestion.name;
}

function renderSuggestion(suggestion, { query }) {
  const matches = AutosuggestHighlightMatch(suggestion.name, query);
  const parts = AutosuggestHighlightParse(suggestion.name, matches);

  return (
      <span>
      {parts.map((part, index) => {
        const className = part.highlight ? 'react-autosuggest__suggestion-match' : null;

        return (
            <span className={className} key={index}>
            {part.text}
          </span>
        );
      })}
    </span>
  );
}

function renderSectionTitle(section) {
  return (
      <span className={section.title.toLowerCase()}>
      {section.title}
    </span>
  );
}

function getSectionSuggestions(section) {
  return section.suggestions;
}

export class Autocomplete extends React.Component {
  constructor() {
    super();

    if (!window.Tefter.cdn) {
      window.Tefter.initTefter();
    }

    let text = 'Search your bookmarks (Press "/" to focus)';

    if (window.Tefter.organizationId) {
      text = `Search ${window.Tefter.orgName}'s bookmarks (Press "/" to focus)`;

      if (window.Tefter.searchType) {
        text = `Search ${window.Tefter.orgName}'s ${window.Tefter.searchType} (Press "/" to focus)`;
      }

      if (window.Tefter.searchType == 'newest') {
        text = `Search across ${window.Tefter.orgName} (Press "/" to focus)`;
      }

      if (window.Tefter.searchType == 'explore') {
        text = `Search across ${window.Tefter.orgName} (Press "/" to focus)`;
      }
    }
    else {
      if (window.Tefter.searchType) {
        text = `Search your ${window.Tefter.searchType} (Press "/" to focus)`;
      }

      if (window.Tefter.searchType == 'newest') {
        text = 'Search across Tefter users (Press "/" to focus)';
      }

      if (window.Tefter.searchType == 'users_search') {
        text = 'Search users (Press "/" to focus)';
      }

      if (window.Tefter.searchType == 'feeds_search') {
        text = 'Search feeds (Press "/" to focus)';
      }

      if (window.Tefter.searchType == 'explore') {
        text = 'Search across Tefter (Press "/" to focus)';
      }

      if (window.Tefter.username) {
        text = `Search ${window.Tefter.username}'s bookmarks (Press "/" to focus)`;
      }
      else if (window.Tefter.user_signed_in == false) {
        text = 'Search across Tefter (Press "/" to focus)';
      }
    }

    // If the devise has touch screen avoid displaying the "/" to
    // focus message.
    if (navigator.maxTouchPoints > 0) {
      text = 'Search for something';
    }

    this.state = {
      value: window.Tefter.keyphrase || '',
      suggestions: [],
      placeholder: text,
      id: '',
      mouseClicked: false
    };

    this.clearInput = this.clearInput.bind(this);
    this.showClearClassName = this.showClearClassName.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // We use this hack to submit form on mouse click and
    // when the input has changed. Alternatively we can
    // wrap the Autocomplete component in a form element.
    if (this.state.mouseClicked == true) {
      document.getElementById(this.props.formID).submit();
    }
  }

  renderInputComponent = inputProps => (
      <div>
      <input {...inputProps} />
      <span className={this.showClearClassName()} onClick={this.clearInput}></span>
      </div>
  )

  clearInput(event) {
    this.setState({ value: '' });
  }

  showClearClassName() {
    const hiddenClass = this.state.value.length == 0 ? 'hidden' : '';
    const className = `icon-cancel-1 clear-search ${hiddenClass}`;

    return className;
  }

  onChange = (event, { newValue, method }) => {
    const mouseClicked = method === 'click' ? true : false;

    this.setState({
      value: newValue,
      id: '',
      mouseClicked: mouseClicked
    });

  };

  onSuggestionsFetchRequested = ({ value }) => {
    getSuggestions(value, this);
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {

    this.setState({
      id: suggestion.id
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions, id } = this.state;
    const inputProps = {
      placeholder: this.state.placeholder,
      value,
      onChange: this.onChange,
      name: 'q',
      id: 'q',
      required: false
    };

    return (
        <div>
        <Autosuggest
      multiSection={true}
      suggestions={suggestions}
      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
      onSuggestionSelected={this.onSuggestionSelected}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      renderInputComponent={this.renderInputComponent}
      renderSectionTitle={renderSectionTitle}
      getSectionSuggestions={getSectionSuggestions}
      inputProps={inputProps}
      highlightFirstSuggestion={false}
        />

        <input type="hidden" value={id} name="s" />
        </div>

    );
  }
}
